<!-- Pré-Insert -->
<ng-template [ngIf]="isShowPreInsertForm">
  <sgt-lead-pre-insert-form
    #preInsertForm
    [isShowOrigem]="isShowOrigem"
    [isShowUsuarioResponsavel]="isShowUsuarioResponsavel"
    [isShowTemperatura]="isShowTemperatura"
    [nome]="preInsertNome"
    (confirm)="onConfirmPreInsert($event)"
  >
  </sgt-lead-pre-insert-form>
</ng-template>

<ng-template [ngIf]="!isShowPreInsertForm">
  <form #form="ngForm" class="lead-form" novalidate>
    <ng-template [ngIf]="entity">
      <!-- Origem -->
      <div class="row" *ngIf="isShowOrigem">
        <div class="form-group col-12 col-xl">
          <label for="origem" class="col-form-label">Origem</label>
          <sgt-origem-select
            *ngIf="config.canEditOrigem"
            #origemSelect
            [idOrigem]="entity.origem"
            (idOrigemChange)="onChangeOrigem($event)"
            [required]="true"
          >
          </sgt-origem-select>

          <sgt-origem-input-group
            *ngIf="!config.canEditOrigem"
            [origem]="entity.origem"
          >
          </sgt-origem-input-group>

          <div class="form-text text-muted">Origem que gerou este lead</div>
        </div>

        <!-- Canal de Venda de Origem -->
        <div
          class="form-group col-12 col-xl"
          *ngIf="config?.isOrigemPossuiCanalVenda"
        >
          <label class="col-form-label">Canal de Venda de Origem</label>
          <sgt-canal-venda-select
            *ngIf="config.canEditOrigem"
            #canalVendaOrigemSelect
            [(idCanalVenda)]="entity.idCanalVendaOrigem"
            [(canalVenda)]="entity.canalVendaOrigem"
            [required]="true"
          >
          </sgt-canal-venda-select>

          <sgt-canal-venda-input-group
            *ngIf="!config.canEditOrigem"
            [canalVenda]="entity.canalVendaOrigem"
          >
          </sgt-canal-venda-input-group>
          <p class="form-text text-muted">
            Canal de venda que originou este lead
          </p>
        </div>

        <!-- Canal de Mídia Social -->
        <div class="form-group col-12 col-xl" *ngIf="isOrigemMidiaSocial()">
          <label for="canalMidiaSocial" class="col-form-label"
            >Canal da Mídia Social</label
          >
          <sgt-canal-midia-social-select
            *ngIf="config.canEditOrigem"
            #canalMidiaSocialSelect
            [idCanalMidiaSocial]="entity.canalMidiaSocial"
            (idCanalMidiaSocialChange)="entity.canalMidiaSocial = $event"
            name="canalMidiaSocial"
            id="canalMidiaSocial"
            [required]="true"
          >
          </sgt-canal-midia-social-select>

          <sgt-canal-midia-social-input-group
            *ngIf="!config.canEditOrigem"
            [canalMidiaSocial]="entity.canalMidiaSocial"
          >
          </sgt-canal-midia-social-input-group>

          <div class="form-text text-muted">
            Canal da mídia social que gerou este lead
          </div>
        </div>
      </div>

      <!-- Campanha de Origem-->
      <div class="row" *ngIf="isOrigemCampanha()">
        <div class="form-group col-12">
          <label for="campanhaOrigem" class="col-form-label"
            >Campanha de Origem</label
          >
          <sgt-campanha-select
            #campanhaOrigemSelect
            [(ngModel)]="entity.idCampanhaOrigem"
            [campanha]="entity.campanhaOrigem"
            (campanhaChange)="onChangeCampanhaOrigem($event)"
            name="campanhaOrigem"
            id="campanhaOrigem"
            #campanhaOrigemModel="ngModel"
            required="required"
            [disabled]="!config.canEditOrigem"
            [objetivoAquisicao]="true"
            [somenteEmAndamento]="true"
          >
          </sgt-campanha-select>
          <div class="form-text text-muted">
            Campanha que originou este lead
          </div>
          <sgt-form-control-error
            *ngIf="
              campanhaOrigemModel.errors &&
              campanhaOrigemModel.errors.required &&
              campanhaOrigemModel.dirty
            "
            msgError="A campanha de origem é obrigatória"
          >
          </sgt-form-control-error>
        </div>
      </div>

      <!-- Campanha de Qualificação -->
      <div class="row" *ngIf="entity.idCampanhaQualificacao">
        <div class="form-group col-12">
          <label class="col-form-label">Campanha de Qualificação</label>
          <input
            type="text"
            class="form-control"
            [value]="entity.campanhaQualificacao?.nome"
            disabled="disabled"
            readonly="readonly"
          />
          <div class="form-text text-muted">
            Campanha que qualificou este lead
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12 col-md" *ngIf="isShowUsuarioResponsavel">
          <label for="usuarioResponsavel" class="col-form-label"
            >Responsável</label
          >
          <sgt-usuario-select
            [idUsuario]="entity.idUsuarioResponsavel"
            (usuarioChange)="onChangeUsuarioResponsavel($event)"
            empityName="Nenhum responsável"
          >
          </sgt-usuario-select>
          <p class="form-text text-muted">Usuário responsável pelo Lead</p>
        </div>
        <div class="form-group col-12 col-md" *ngIf="isShowTemperatura">
          <label for="temperatura" class="col-form-label">Temperatura</label>
          <sgt-temperatura-select [(idTemperatura)]="entity.temperatura">
          </sgt-temperatura-select>
        </div>
      </div>

      <div class="row" *ngIf="config?.podeCadastrarLeadExterior">
        <div class="form-group col-12">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              [(ngModel)]="entity.exterior"
              name="exterior"
              id="exterior"
            />
            <label class="custom-control-label" for="exterior">Exterior?</label>
          </div>
          <p class="form-text text-muted form-text-codigo-integracao">
            Marque esta opção se for um lead do exterior
          </p>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12" [ngClass]="{ 'col-md': !isMini }">
          <label for="pessoaTipo" class="col-form-label">Tipo</label>
          <select
            class="form-control"
            name="pessoaTipo"
            id="pessoaTipo"
            [ngModel]="entity.tipoPessoa || ''"
            (ngModelChange)="entity.tipoPessoa = $event ? $event : null"
            #pessoaTipo="ngModel"
            required="required"
          >
            <option
              *ngFor="let pessoaTipo of pessoaTipos"
              [ngValue]="pessoaTipo.id"
            >
              {{ pessoaTipo.nome }}
            </option>
          </select>
          <sgt-form-control-error
            *ngIf="
              pessoaTipo.errors &&
              pessoaTipo.errors.required &&
              pessoaTipo.dirty
            "
            msgError="O tipo é obrigatório"
          >
          </sgt-form-control-error>
        </div>
        <div class="form-group col-12" [ngClass]="{ 'col-md': !isMini }">
          <label for="cnpjCpf" class="col-form-label">{{
            getLabelCnpjCpfByTipo()
          }}</label>
          <div class="input-group">
            <div
              class="input-group-prepend"
              *ngIf="entity.identificadorMatrizFilial"
            >
              <sgt-identificador-matriz-filial-input-group-text
                [identificador]="entity.identificadorMatrizFilial"
                [prepend]="true"
              >
              </sgt-identificador-matriz-filial-input-group-text>
            </div>

            <input
              type="text"
              class="form-control"
              [(ngModel)]="entity.cnpjCpf"
              name="cnpjCpf"
              id="cnpjCpf"
              #cnpjCpf="ngModel"
              #cnpjCpfInput
              [ngControl]="cnpjCpf"
              [sgtCnpjCpf]="entity.tipoPessoa"
              [required]="isCnpjCpfRequired()"
              [isValidate]="mustValidateCnpjCpf()"
              [isApplyMask]="!isLeadExterior"
              (blur)="onValidarCnpjCpfCadastrado()"
            />

            <div class="input-group-append" *ngIf="isConsultandoCnpj">
              <span class="input-group-text">
                <i class="fas fa-spinner fa-pulse"></i> Consultando CNPJ
              </span>
            </div>
          </div>
          <label
            class="col-form-label ignorar-cnpj-cpf-invalido"
            *ngIf="usuarioPodeSalvarCnpjCpfInvalido"
          >
            <input
              type="checkbox"
              [(ngModel)]="ignorarCnpjCpfInvalido"
              name="ignorarCnpjCpfInvalido"
              id="ignorarCnpjCpfInvalido"
              tabindex="-1"
            />
            Ignorar {{ getLabelCnpjCpfByTipo() }} inválido
          </label>

          <sgt-form-control-error
            *ngIf="cnpjCpf.errors && cnpjCpf.errors.required && cnpjCpf.dirty"
            msgError="{{
              'O ' +
                (entity.tipoPessoa
                  ? isTipoPessoaFisica()
                    ? 'CPF'
                    : 'CNPJ'
                  : 'CNPJ / CPF') +
                ' é obrigatório'
            }}"
          >
          </sgt-form-control-error>
          <sgt-form-control-error
            *ngIf="cnpjCpf.errors && cnpjCpf.errors.cnpjCpfInvalido"
            msgError="{{
              (isTipoPessoaFisica() ? 'CPF' : 'CNPJ') + ' inválido'
            }}"
          >
          </sgt-form-control-error>
        </div>
      </div>

      <!-- Situação Cadastral -->
      <div class="row" *ngIf="isTipoPessoaJuridica()">
        <div
          class="form-group col-12"
          [ngClass]="{ 'col-md-6 col-xl-3': !isMini }"
        >
          <label for="empresaSituacaoCadastral" class="col-form-label"
            >Situação Cadastral Empresa</label
          >
          <input
            type="text"
            class="form-control text-center"
            [value]="entity.situacaoCadastral | empresaSituacaoCadastral"
            name="empresaSituacaoCadastral"
            id="empresaSituacaoCadastral"
            disabled="disabled"
            readonly="readonly"
          />
          <p class="form-text text-muted">
            Situação da empresa junto à Receita Federal do Brasil (RFB)
          </p>
        </div>
        <div
          class="form-group col-12"
          [ngClass]="{ 'col-md-6 col-xl-3': !isMini }"
        >
          <label for="empresaSituacaoCadastralData" class="col-form-label"
            >Data Situação Cadastral</label
          >
          <input
            type="text"
            class="form-control text-center"
            [value]="entity.situacaoCadastralData | date : 'dd/MM/yyyy'"
            name="empresaSituacaoCadastralData"
            id="empresaSituacaoCadastralData"
            disabled="disabled"
            readonly="readonly"
          />
          <p class="form-text text-muted">
            Data da última atualização da situação cadastral
          </p>
        </div>
        <div
          class="form-group col-12 col-md"
          *ngIf="entity.situacaoCadastralMotivoCodigo"
        >
          <label class="col-form-label">Motivo Situação Cadastral </label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                {{ entity.situacaoCadastralMotivoCodigo }}
              </span>
            </div>
            <input
              type="text"
              class="form-control"
              [value]="entity.situacaoCadastralMotivoNome"
              name="empresaSituacaoCadastralMotivoNome"
              id="empresaSituacaoCadastralMotivoNome"
              disabled="disabled"
              readonly="readonly"
            />
          </div>
          <p class="form-text text-muted">Motivo da situação cadastral</p>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12 col-md">
          <label for="dataCadastroInput" class="col-form-label"
            >Data de Cadastro</label
          >
          <input
            type="text"
            class="form-control text-center"
            [value]="entity.dataCadastro | date : 'dd/MM/yyyy'"
            name="dataCadastroInput"
            id="dataCadastroInput"
            disabled="disabled"
            readonly="readonly"
          />
        </div>
        <div class="form-group col-12 col-md">
          <label for="dataFundacao" class="col-form-label">
            <span *ngIf="isTipoPessoaFisica()">Data de Nascimento</span>
            <span *ngIf="!isTipoPessoaFisica()">Data de Abertura</span>
          </label>
          <sgt-datepicker
            [(ngModel)]="entity.dataFundacao"
            name="dataFundacao"
            id="dataFundacao"
            #dataFundacao="ngModel"
            [ngControl]="dataFundacao"
          >
          </sgt-datepicker>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <label for="nome" class="col-form-label">
            <span *ngIf="isTipoPessoaFisica()">Nome</span>
            <span *ngIf="!isTipoPessoaFisica()">Razão Social</span>
          </label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="entity.nome"
            name="nome"
            id="nome"
            #nome="ngModel"
            required="required"
            maxlength="255"
            sgtUppercase
            #nomeInput
          />
          <sgt-form-control-error
            *ngIf="nome.errors && nome.errors.required && nome.dirty"
            msgError="O nome é obrigatório"
          >
          </sgt-form-control-error>
          <sgt-form-control-error
            *ngIf="nome.errors && nome.errors.maxlength"
            msgError="O nome deve ter no máximo 255 caracteres"
          >
          </sgt-form-control-error>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-12">
          <label for="nomeFantasia" class="col-form-label">
            <span *ngIf="isTipoPessoaFisica()">Apelido</span>
            <span *ngIf="!isTipoPessoaFisica()">Nome Fantasia</span>
          </label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="entity.nomeFantasia"
            name="nomeFantasia"
            id="nomeFantasia"
            #nomeFantasia="ngModel"
            maxlength="255"
            sgtUppercase
          />
          <sgt-form-control-error
            *ngIf="nomeFantasia.errors && nomeFantasia.errors.maxlength"
            msgError="O nome fantasia deve ter no máximo 255 caracteres"
          >
          </sgt-form-control-error>
        </div>
      </div>

      <div class="row" *ngIf="isTipoPessoaJuridica()">
        <!-- Porte Empresa -->
        <div class="form-group col-12" [ngClass]="{ 'col-md': !isMini }">
          <sgt-porte-empresa-form-control
            [codigo]="entity.porteEmpresaCodigo"
            [nome]="entity.porteEmpresaNome"
          >
          </sgt-porte-empresa-form-control>
        </div>

        <!-- Natureza Jurídica -->
        <div class="form-group col-12" [ngClass]="{ 'col-md': !isMini }">
          <sgt-natureza-juridica-form-control
            [codigo]="entity.naturezaJuridicaCodigo"
            [nome]="entity.naturezaJuridicaNome"
          >
          </sgt-natureza-juridica-form-control>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12 col-md">
          <label for="periodicidadeCompra" class="col-form-label"
            >Periodicidade de Compra</label
          >
          <sgt-periodicidade-compra-select
            [pendingSelectionId]="entity.idPeriodicidadeCompra"
            [selectorSettings]="selectPeriodicidadeCompraSettings"
            [isToShowTabelaVigenciaCarteiraCliente]="true"
            [enableAutoSelectSingleOption]="true"
            (changed)="onChangePeriodicidadeCompra($event)"
          >
          </sgt-periodicidade-compra-select>
        </div>
      </div>

      <!-- Classificações -->
      <sgt-lead-classificacao-form
        #leadClassificacaoForm
        [idLead]="entity.id"
        [(entities)]="entity.classificacoes"
      >
      </sgt-lead-classificacao-form>

      <div class="row">
        <div class="form-group col-12 col-md">
          <label for="regiao" class="col-form-label">Região</label>
          <sgt-regiao-select
            #regiaoSelect
            [(ngModel)]="entity.idRegiao"
            [regiao]="entity.regiao"
            #regiao="ngModel"
            name="regiao"
            id="regiao"
            [required]="configCliente?.obrigarRegiao"
            [somenteAtivas]="true"
          >
          </sgt-regiao-select>
          <sgt-form-control-error
            *ngIf="regiao.errors && regiao.errors.required && regiao.dirty"
            msgError="A região é obrigatória"
          >
          </sgt-form-control-error>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <label for="anotacao" class="col-form-label">Anotação</label>
          <textarea
            class="form-control"
            [(ngModel)]="entity.anotacao"
            name="anotacao"
            id="anotacao"
            #anotacao="ngModel"
            rows="5"
            sgtUppercase
          >
          </textarea>
        </div>
      </div>

      <!-- Simples Nacional -->
      <sgt-collapse-group
        title="Simples Nacional"
        [isCollapsedInDefault]="false"
        *ngIf="isTipoPessoaJuridica()"
      >
        <div class="row">
          <div class="form-group col-12">
            <sgt-simples-nacional-form
              #simplesNacionalForm
              [entity]="entity"
              [isMini]="isMini"
            >
            </sgt-simples-nacional-form>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-12">
            <sgt-mei-form #meiForm [entity]="entity" [isMini]="isMini">
            </sgt-mei-form>
          </div>
        </div>
      </sgt-collapse-group>

      <!-- CNAEs e QSA -->
      <sgt-collapse-group title="CNAEs e QSA" [isCollapsedInDefault]="false">
        <div class="row">
          <div class="form-group col-12">
            <sgt-cnaes-view
              [cnaePrincipal]="entity.cnaePrincipal"
              [cnaesSecundarias]="
                entity.cnaesSecundarias | cnaeSecundariasViewerMap
              "
            >
            </sgt-cnaes-view>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-12" [ngClass]="{ 'col-md-4': !isMini }">
            <sgt-capital-social-form-control-text
              [capitalSocial]="entity.capitalSocial"
            >
            </sgt-capital-social-form-control-text>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-12">
            <sgt-socio-view [socios]="entity.socios"> </sgt-socio-view>
          </div>
        </div>
      </sgt-collapse-group>

      <!-- Internet -->
      <sgt-collapse-group title="Internet">
        <div class="row">
          <div class="form-group col-12" [ngClass]="{ 'col-md': !isMini }">
            <label for="emailNfe" class="col-form-label">E-mail NF-e</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <a
                  href="mailto:{{ entity.emailNfe }}"
                  class="btn btn-light"
                  tabindex="-1"
                >
                  <i class="far fa-envelope" aria-hidden="true"></i>
                </a>
              </div>
              <input
                type="email"
                class="form-control"
                [(ngModel)]="entity.emailNfe"
                name="emailNfe"
                id="emailNfe"
                #emailNfe="ngModel"
                maxlength="255"
                sgtLowercase
              />
            </div>
            <sgt-form-control-error
              *ngIf="emailNfe.errors && emailNfe.errors.maxlength"
              msgError="O e-mail NF-e deve ter no máximo 255 caracteres"
            >
            </sgt-form-control-error>
          </div>
          <div
            class="form-group col-12"
            [ngClass]="{ 'col-md': !isMini }"
            *ngIf="configCliente?.exibirEmailBoleto"
          >
            <label for="emailBoleto" class="col-form-label"
              >E-mail Boleto</label
            >
            <div class="input-group">
              <div class="input-group-prepend">
                <a
                  href="mailto:{{ entity.emailBoleto }}"
                  class="btn btn-light"
                  tabindex="-1"
                >
                  <i class="far fa-envelope" aria-hidden="true"></i>
                </a>
              </div>
              <input
                type="email"
                class="form-control"
                [(ngModel)]="entity.emailBoleto"
                name="emailBoleto"
                id="emailBoleto"
                #emailBoleto="ngModel"
                maxlength="255"
                sgtLowercase
              />
            </div>
            <sgt-form-control-error
              *ngIf="emailBoleto.errors && emailBoleto.errors.maxlength"
              msgError="O e-mail boleto deve ter no máximo 255 caracteres"
            >
            </sgt-form-control-error>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-12">
            <label for="site" class="col-form-label">Site</label>
            <input
              type="url"
              class="form-control"
              [(ngModel)]="entity.site"
              name="site"
              id="site"
              #siteModel="ngModel"
              maxlength="500"
            />
            <sgt-form-control-error
              *ngIf="siteModel.errors && siteModel.errors.maxlength"
              msgError="O site deve ter no máximo 500 caracteres"
            >
            </sgt-form-control-error>
          </div>
        </div>
      </sgt-collapse-group>

      <!-- Contato Principal -->
      <sgt-collapse-group title="Contato Principal">
        <sgt-lead-contato-unico
          #formContatoPrincipal
          [tipoContato]="tipoContatoPrincipal"
          [(entity)]="entity.contatoPrincipal"
          [telefoneRequired]="false"
          [permiteExcluir]="false"
          [exterior]="isLeadExterior"
          [isMini]="isMini"
        >
        </sgt-lead-contato-unico>
      </sgt-collapse-group>

      <!-- Outros Contatos -->
      <sgt-collapse-group
        title="Outros Contatos"
        [isCollapsedInDefault]="false"
      >
        <sgt-lead-contato
          [idLead]="entity.id"
          [entities]="entity.outrosContatos"
          #leadOutrosContatosCadastro
          [showTableTitle]="false"
          [isMini]="isMini"
        >
        </sgt-lead-contato>
      </sgt-collapse-group>

      <!-- Endereço Principal-->
      <sgt-collapse-group title="Endereço Principal">
        <sgt-lead-endereco-unico
          #formEnderecoPrincipal
          [tipoEndereco]="tipoEnderecoPrincipal"
          [(entity)]="entity.enderecoPrincipal"
          [idRepresentante]="idRepresentante"
          [permiteExcluir]="false"
          [exterior]="isLeadExterior"
          [exibirInscricaoSuframa]="configCliente?.exibirInscricaoSuframa"
          [exibirInscricaoProdutorRural]="
            configCliente?.exibirInscricaoProdutorRural
          "
          [isMini]="isMini"
        >
        </sgt-lead-endereco-unico>
      </sgt-collapse-group>
    </ng-template>
  </form>
</ng-template>
